import { render, staticRenderFns } from "./ModalTitleParts.vue?vue&type=template&id=4a2296c8&scoped=true"
import script from "./ModalTitleParts.vue?vue&type=script&lang=ts"
export * from "./ModalTitleParts.vue?vue&type=script&lang=ts"
import style0 from "./ModalTitleParts.vue?vue&type=style&index=0&id=4a2296c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2296c8",
  null
  
)

export default component.exports